import styled from 'styled-components';
export const Container = styled.div `
  display: grid;
  gap: 16px;
`;
export const Item = styled.div `
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 16px;
  align-items: flex-start;
`;
export const ItemStatus = styled.div `
  display: inline-flex;
  vertical-align: top;
  margin-left: 10px;
`;
export const ItemTextContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;
